import React, { useRef, useEffect } from "react";
import ReactModal from "react-modal";

ReactModal.setAppElement("#root"); // important for a11y; also avoids some iOS weirdness

export default function MondayFormModal({ isOpen, onClose, formUrl }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    // If you previously initialized iFrameResizer, disable autosizing so CSS controls height.
    if (window.iFrameResize && iframeRef.current) {
      window.iFrameResize(
        { autoResize: false, checkOrigin: ["https://forms.monday.com"] },
        iframeRef.current
      );
    }
  }, [isOpen]);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      // keep overlay scrollable if content exceeds viewport (keyboard on mobile)
      style={{
        overlay: {
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,.45)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4vh 3vw",
          zIndex: "1000",
        },
        content: {
          inset: 0,
          border: "none",
          background: "transparent",
          padding: 0,
        },
      }}
    >
      <div
        style={{
          background: "#fff",
          width: "min(920px,94vw)",
          margin: "5vh auto",
          minHeight: "88vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0,0,0,.25)",
        }}
      >
        <div
          style={{
            flex: "0 0 auto",
            padding: "12px 16px",
            borderBottom: "1px solid #eee",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              background: "none",
              border: 0,
              fontSize: 22,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {/* SCROLL LIVES HERE */}
        <div
          style={{
            flex: "1 1 auto",
            minHeight: "90vh",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {/* Strategy A: iframe fills scroll area */}
          <iframe
            ref={iframeRef}
            title="Monday form"
            src={formUrl} // e.g. https://forms.monday.com/forms/embed/XXXX
            style={{
              display: "block",
              width: "100%",
              minHeight: "90vh",
              border: 0,
            }}
            frameBorder="0"
            scrolling="yes"
            allow="fullscreen"
          />
        </div>
      </div>
    </ReactModal>
  );
}
